import { render, staticRenderFns } from "./c_home_coupon.vue?vue&type=template&id=141fe8b9&scoped=true&"
import script from "./c_home_coupon.vue?vue&type=script&lang=js&"
export * from "./c_home_coupon.vue?vue&type=script&lang=js&"
import style0 from "./c_home_coupon.vue?vue&type=style&index=0&id=141fe8b9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141fe8b9",
  null
  
)

export default component.exports